import React from 'react';
import format from 'date-fns/format';

import { shortDateTimeFormat } from '@crm-package/app';

import { INotificationGridItem } from '../notification-grid';

import { DetailsRow } from './DetailsRow';
import { LeadInfo } from './utils';

export const NewLeadDepositCardUsedDetails: React.FC<INotificationGridItem> = ({
  date,
  notificationDetails: { data },
}) => {
  const message = `New Card * ${data.cardLast4Digits} ${
    data.cardExpirationMonth
  }/${data.cardExpirationYear} added ${format(
    new Date(data.transactionCompletedDate),
    shortDateTimeFormat
  )}.`;

  const teamManager = data.managerId ? (
    <DetailsRow
      label="Manager ID"
      value={`${data.managerId}, ${data.managerName}`}
    />
  ) : null;

  return (
    <>
      <DetailsRow label="Date" value={date} />
      <DetailsRow
        label="Client ID"
        component={<LeadInfo leadId={data.leadId} />}
      />
      <DetailsRow label="Name" value={data.leadFullName} />
      <DetailsRow label="Message" value={message} />
      {teamManager}
    </>
  );
};
